import { makeLookup } from '@aloft/toolkit-shared';

import { SectionID } from './types.ts';

export const getSectionTitle = makeLookup<SectionID, string>({
  cases: [
    ['personal', 'Personal Information'],
    ['contact', 'Contact Information'],
    ['mls', 'MLS Information'],
    ['subscription', 'Subscription Management'],
  ],
});
